import { useEffect } from 'react';

/**
 * Reusable Hooks replaces
 * addEventListeners in functional layouts
 */

export type UseEventArgs<T> = {
  name: string;
  handler: (evt: CustomEvent<T>) => void | Promise<void>;
  target?: HTMLElement | Window;
  options?: any;
};

export const useEvent = <T>({ name, handler, target = window, options }: UseEventArgs<T>) => {
  useEffect(() => {
    if (!handler || !target) {
      return;
    }

    target.addEventListener(name, handler as EventListener, options);
    // Cleanup
    return () => {
      target.removeEventListener(name, handler as EventListener, options);
    };
  }, [name, handler, target, options]);
};
